import type { FC, ReactNode } from 'react';
import { useContext } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { FallbackContent } from '../../providers/error-boundary-provider/fallback-content';

import { SchedulesErrorBoundaryContext } from './schedules-error-boundary.context';

interface SchedulesErrorBoundaryProps {
  children: ReactNode;
}

export const SchedulesErrorBoundary: FC<SchedulesErrorBoundaryProps> = ({
  children,
}) => {
  const { captureException } = useContext(SchedulesErrorBoundaryContext);
  return (
    <ReactErrorBoundary
      FallbackComponent={FallbackContent}
      onError={(error, errorInfo) => {
        // Log to Sentry
        captureException(error, {
          level: 'error',
          tags: {
            component: 'SchedulesPage',
            feature: 'schedules',
            errorBoundary: 'SchedulesErrorBoundary',
          },
          extra: {
            errorInfo,
          },
        });
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};
